/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const IncidentReportType = {
    TrafficAccident: 'TrafficAccident',
    LawEnforcement: 'LawEnforcement',
    RoadRage: 'RoadRage',
    BadDriving: 'BadDriving'
};
export function IncidentReportTypeFromJSON(json) {
    return IncidentReportTypeFromJSONTyped(json, false);
}
export function IncidentReportTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function IncidentReportTypeToJSON(value) {
    return value;
}
